module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewPreviousLoanRecord"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printPreviousLoanRecord()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printPreviousLoanRecord"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord.member) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table printing"
  }, [_c('thead', [_c('td', {
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "90",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                        "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                        ")]), _c('br'), _c('br'), _c('strong', [_vm._v("Previous Loan Records")])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.seeRecord.member) ? _c('p', [_vm._v("Customer Name : " + _vm._s(_vm.seeRecord.member.name))]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.memberloanplans), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.applicationNo))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.type))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.collection_center_id) ? _c('span', [_vm._v(_vm._s(row.collection_center.name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.branch.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.disbursement.disbursementDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.totalAmt))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.receivedAmt))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.status == 'pending') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v(_vm._s(row.status))]) : _vm._e(), _vm._v(" "), (row.status == 'processing') ? _c('span', {
      staticClass: "label label-info"
    }, [_vm._v(_vm._s(row.status))]) : _vm._e(), _vm._v(" "), (row.status == 'sattlement') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v(_vm._s(row.status))]) : _vm._e(), _vm._v(" "), (row.status == 'complete') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v(_vm._s(row.status))]) : _vm._e()])])
  }), 0)])])])])]), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr. No.")]), _vm._v(" "), _c('th', [_vm._v("LoanID ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("CenterName")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Branch")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Disb Date")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Rec. Amt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Status")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            CLOSE\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-096d11cb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/components/PreviousLoanRecord.vue
// module id = 755
// module chunks = 0